export default __webpack_public_path__ + "/dist/images/6314847.48fb81a16a4a8c0728bf9361c10144ee.png";